export default __webpack_public_path__ + "static/media/ic-folder1.914266cd.svg";